export const ClaimEventsStatuses = {
  INCOMPLETE: 'INCOMPLETE',
  COMPLETE: 'COMPLETE',
} as const;

export type ClaimEventStatus =
  (typeof ClaimEventsStatuses)[keyof typeof ClaimEventsStatuses];
